import api, { ApiRequest, ApiResult } from '../../../api/api-caller';
import { TooltipData } from '../components/Tooltip';

export interface GraphicalProperties {
  id: number;
  x: number;
  y: number;
  width: number;
  height: number;
  instanceid: number;
  zorder: number;
}

const emptyGraphicalProperties: GraphicalProperties = {
  id: 0,
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  instanceid: 0,
  zorder: 0
};
export interface CanvasLayoutElement {
  id: string;
  name: string;
  typename: string;
  tooltipData?: TooltipData;
  graphicalproperties: GraphicalProperties;
}
let title: string = '';
let elements: CanvasLayoutElement[] = [];
const fetchData = async (componentId: string | null, attributes?: string): Promise<ApiResult> => {
  if (attributes)
    // eslint-disable-next-line no-param-reassign
    attributes = ` id, name, typename, parent.name(as="pageTitle"), graphicalproperties, ${attributes.replace(
      / /g,
      '-'
    )}`;
  // eslint-disable-next-line no-param-reassign
  else attributes = 'id, name, typename, parent.name(as="pageTitle"), graphicalproperties';
  const query: ApiRequest = {
    body: {
      query: `[${componentId}].subobjects(criteria="typegroupname<>\\"Connector\\"")`,
      attributes,
      jsonmode: 2
    },
    method: 'POST'
  };
  const result: ApiResult = await api.asyncCallApi('meaquery', query);

  return result;
};

export const getData = async (
  containerId: string | null,
  attributes?: string
): Promise<CanvasLayoutElement[]> => {
  title = '';
  elements = [];
  const result: ApiResult = await fetchData(containerId, attributes);
  if (result && result.data) {
    const data = JSON.parse(result.data).elements[0];
    if (data && data.elements && data.elements.length) {
      title = data.elements[0].attributes.pageTitle;
      elements = data.elements.map(
        (obj: {
          attributes: { [x: string]: any; name?: any; id?: any; typename?: any };
          elements: { elements: { attributes: any }[] }[];
        }) => {
          const tooltipData: TooltipData = { name: obj.attributes.name, attributes: [] };
          Object.keys(obj.attributes).forEach(
            key =>
              obj.attributes[key] &&
              !['id', 'name', 'typename', 'pageTitle'].includes(key) &&
              (key.toLowerCase().trim() === 'description'
                ? tooltipData.attributes.push({ key: 'description', value: obj.attributes[key] })
                : tooltipData.attributes.push({ key, value: obj.attributes[key] }))
          );
          tooltipData.description = tooltipData.attributes.find(
            x => x.key === 'description'
          )?.value;
          const { id, name, typename } = obj.attributes;
          const idparts = String(id).split('.');
          const instanceid = idparts[idparts.length - 1];
          return {
            id,
            name,
            typename,
            tooltipData,
            graphicalproperties:
              (obj.elements &&
                obj.elements[0].elements &&
                (obj.elements[0].elements.find(x => x.attributes.instanceid === instanceid)
                  ?.attributes ||
                  //  in case of not found - you may use first
                  obj.elements[0].elements[0].attributes)) ||
              //  or you may use empty
              // emptyGraphicalProperties)) ||
              emptyGraphicalProperties
          };
        }
      );

      elements = elements.filter(e => e.graphicalproperties !== emptyGraphicalProperties);
      //  if any x is negative -then  normalize x for all elements
      const minx: number = elements
        .map(e => e.graphicalproperties.x)
        .sort((x1, x2) => Number(x1) - Number(x2))[0];
      if (minx < 0)
        elements = elements.map(e => {
          e.graphicalproperties.x = Number(e.graphicalproperties.x) - minx + 50; // white space around
          return e;
        });

      //  if any y is negative -then  normalize y for all elements
      const miny: number = elements
        .map(e => e.graphicalproperties.y)
        .sort((y1, y2) => Number(y1) - Number(y2))[0];
      if (miny < 0)
        elements = elements.map(e => {
          e.graphicalproperties.y = Number(e.graphicalproperties.y) - miny + 50; // white space around
          return e;
        });
      return elements.sort(
        (a: CanvasLayoutElement, b: CanvasLayoutElement) =>
          a.graphicalproperties.zorder - b.graphicalproperties.zorder
      );
    }
  }
  return [];
};
export const getTooltipData = (id: string | null): TooltipData => {
  const bar: CanvasLayoutElement | undefined = elements.find(b => b.id === id);
  return bar?.tooltipData || { attributes: [] };
};

export const getTitle = () => title;
export const isInited = () => elements && elements.length;
